<template>
  <b-container>
    <b-row>
      <h1>{{ $t("system.systemFieldType.edit") }}</h1>
      <success-fade-alert ref="alert" :msg="alert.success" />
      <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />
    </b-row>

    <crud-data ref="crudData" :model="model" :modelstate="modelstate" class="mb-4"></crud-data>

    <b-button class="button" size="sm" @click="save" :disabled="submitted">
      {{ $t("geral.save") }}
    </b-button>
    <!-- {{ model }} -->
  </b-container>
</template>

<script>
export default {
  name: "CreateSystemFieldType",
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    CrudData: () =>
      import("@/components_rms/System/SystemFieldType/CrudData.vue"),
  },
  props: {
    id: String,
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Registro criado com sucesso",
      },
      submitted: false,
      modelstate: {},
      model: {
        id: 0,
        DefaultValue: "",
        DefaultGeraAnomalia: 2,
        DefaultPermiteAnexo: false,
        DisplayName: "",
        FieldType: 7,
        ScriptPythonLoadData: "",
        ScriptPythonProcess: "",
      },
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.$apiChecklist
        .get("/systemFieldType/get/" + this.id.toString())
        .then((response) => {
          this.model = response.data.data;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              if (error.response.status == 400) {
                this.modelstate = error.response.data.errors;
                this.alert.error = "Load data error";
              } else {
                if (error.response.data) {
                  this.alert.error = error.response.data.errors;
                } else {
                  this.alert.error = `${error.response.status} - ${error.response.statusText} `;
                }
              }
            } else {
              this.alert.error = error.message;
            }
            this.$refs.fadeAlertDanger.show();
            window.scrollTo(0, 0);
          }
        });
    },
    save() {
      this.submitted = true;
      this.$apiChecklist
        .post("/systemFieldType/edit/" + this.model.id.toString(), this.model)
        .then((response) => {
          if (response.data.success) {
            this.model = response.data.data;
            this.$refs.alert.show();
            this.modelstate = {};
            window.scrollTo(0,0);
          } else {
            this.alert.error = response.data.title;
            this.$refs.fadeAlertDanger.show();
            window.scrollTo(0,0);
          }
          this.submitted = false;
        })
        .catch((error) => {
          this.submitted = false;
          this.modelstate = {};

          if (error.response) {
            if (error.response.status == 400) {
              this.modelstate = error.response.data.errors;
              this.alert.error = "Verifique os dados informados";
              this.$refs.fadeAlertDanger.show();
              window.scrollTo(0, 0);
            } else {
              this.alert.error = error.response.data.errors;
              this.$refs.fadeAlertDanger.show();
              window.scrollTo(0, 0);
            }
          } else {
            console.log(error);
            this.alert.error = error.message;
            this.$refs.fadeAlertDanger.show();
            window.scrollTo(0, 0);
          }
        });
    },
  },
};
</script>
